module.exports = __webpack_public_path__ + "static/img/grow1_light.a9a9044f.png";